import { render, staticRenderFns } from "./SoftwareSystem.vue?vue&type=template&id=ba930666&scoped=true&"
import script from "./SoftwareSystem.vue?vue&type=script&lang=js&"
export * from "./SoftwareSystem.vue?vue&type=script&lang=js&"
import style0 from "./SoftwareSystem.vue?vue&type=style&index=0&id=ba930666&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba930666",
  null
  
)

export default component.exports